<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	.top
		width:100%;
		position: relative;
		.top-img
			width:100%
			height:350px
		.top-main
			position: absolute;
			top:100px;
			left:45%;
			.top-main-title
				width:228px;
				height:53px;
				font-size:38px;
				font-weight:500;
				color:rgba(255,255,255,1);
				line-height:53px;
			.top-main-desc
				width:546px;
				height:60px;
				font-size:16px;
				font-weight:400;
				color:rgba(255,255,255,1);
				line-height:30px;
		.top-btn
			position: absolute;
			bottom:-32px;
			left:42%;
			display:flex
			width:302px;
			height:64px;
			justify-content:center;
			align-items:center;
			cursor:pointer;
			background:rgba(247,171,59,1);
			box-shadow:0px 19px 40px 0px rgba(247,171,59,0.57);
			border-radius:32px;
			.top-btn-img
				width:34px;
				height:36px;
				margin-right:12px;
			.top-btn-desc
				height:32px;
				font-size:25px;
				font-weight:500;
				color:rgba(255,255,255,1);
				line-height:31px;
	.answer
		text-align:center;
		.a-title
			height:53px;
			font-size:38px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:53px;
			margin-top:100px;
		.a-list
			display:flex;
			justify-content:center;
			margin-top:50px;
			.a-lists
				margin:0 69px;
				.a-img
					width:281px;
					height:281px;
				.a-name
					height:28px;
					font-size:20px;
					font-weight:400;
					color:rgba(7,19,54,0.8);
					line-height:28px;
					margin-top:10px;
	.process
		.p-title
			text-align:center;
			height:53px;
			font-size:38px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:53px;
			margin-top:100px;
		.p-list
			display:flex;
			justify-content:center;
			margin-top:43px;
			// position:relative;
			.p-lists
				margin:0 22px;
				display:flex;
				width:286px;
				height:165px;
				background:rgba(255,255,255,1);
				box-shadow:0px 2px 20px 0px rgba(225,225,225,0.5);
				border-radius:10px;
				position:relative;
				.p-img
					width:30px;
					height:40px;
					margin:26px 0 0 28px;
					flex-shrink: 0;
				.p-right
					margin:31px 30px 0 12px;
					.p-name
						height:28px;
						font-size:20px;
						font-weight:500;
						color:rgba(7,19,54,1);
						line-height:28px;
					.p-desc
						height:44px;
						font-size:16px;
						font-weight:400;
						color:rgba(7,19,54,0.6);
						line-height:22px;
						margin-top:10px;
				.p-img-bj
					position: absolute;
					z-index:-1;
					right:-21px;
					bottom:-22px;
					width:85px;
					height:86px;
	.case
		margin-bottom:133px;
		.c-title
			text-align:center;
			height:53px;
			font-size:38px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:53px;
			margin-top:100px;
		.c-list
			display:flex;
			justify-content:center;
			margin-top:64px;
			.c-que
				width:273px;
				height:470px;
				margin-right:50px;
				position: relative;
				.que-t
					position: absolute;
					left:-25px;
					top:-25px;
					width:50px;
					height:50px;
					line-height:50px;
					text-align:center;
					background:rgba(240,148,67,1);
					border-radius:43px;
					color:#FFFFFF;
					font-size:30px;
				.que-img
					position: absolute;
					left:20px;
					top:-75px;
					width:76px;
					height:62px;
				.que-main
					width:273px;
					height:470px;
					line-height:34px;
					background:rgba(241,244,252,1);
					border-radius:10px;
					padding:40px;
					font-size:16px;
					font-weight:400;
					color:rgba(85,85,85,1);
			.c-ans
				width:970px;
				height:470px;
				position: relative;
				.ans-t
					position: absolute;
					left:-25px;
					top:-25px;
					width:50px;
					height:50px;
					line-height:50px;
					text-align:center;
					background:rgba(240,148,67,1);
					border-radius:43px;
					color:#FFFFFF;
					font-size:30px;
				.ans-main
					width:970px;
					height:470px;
					line-height:34px;
					background:rgba(241,244,252,1);
					border-radius:10px;
					background:rgba(241,244,252,1);
					border-radius:10px;
					padding:40px;
					font-size:16px;
					font-weight:400;
					color:rgba(85,85,85,1);
					.ans-list
						display:flex;
						font-size:18px;
						font-weight:500;
						color:rgba(255,255,255,1);
						text-align:center;
						margin-bottom:20px;
						.ans-btn-che
							width:105px;
							height:35px;
							line-height:35px;
							background:rgba(47,75,155,1);
							margin-right:17px;
							cursor:pointer;
						.ans-btn
							width:105px;
							height:35px;
							line-height:35px;
							background:rgba(141,189,244,1);
							margin-right:17px;
							cursor:pointer;
	.consult-icon
		cursor:pointer;
		position: fixed;
		top: 330px;
		right:0px;
		z-index: 2000;
		width:108px;
		height:72px;
		background:rgba(39,81,203,1);
		box-shadow:0px 2px 15px 0px rgba(61,92,170,0.46);
		text-align:center;
		line-height:72px;
		.consult-img
			position:absolute;
			width:40px;
			height:40px;
			top:-20px;
			left:34px;
		.consult-name
			font-size:18px;
			font-weight:400;
			color:rgba(255,255,255,1);
</style>
<template>
  <div class="main">
    <div class="top">
    	<img src="/static/img/banner_consult.png" class="top-img">
    	<div class="top-main">
    		<div class="top-main-title">企业法律咨询</div>
    		<div class="top-main-desc">8000+在线律师提供优质的付费咨询服务，平台根据用户咨询，第一时间自动响应，接入专业对口、地域相近、价格合理的资深律师进行专业的解答。</div>
    	</div>
    	<div class="top-btn" @click="gotoHonsenChat">
    		<img src="/static/img/consult-w.png" class="top-btn-img">
    		<div class="top-btn-desc">立即咨询</div>
    	</div>
    </div>
    <div class="answer">
    	<div class="a-title">解答标准</div>
    	<div class="a-list">
    		<div v-for="item in consultAnswer" class="a-lists">
    			<img :src="item.src" class="a-img">
    			<div class="a-name">{{item.name}}</div>
    		</div>
    	</div>
    </div>
    <div class="process">
    	<div class="p-title">解答流程</div>
    	<div class="p-list">
    		<div v-for="(item , index) in consultProcess" class="p-lists">
    			<img v-if="index == 3" src="/static/img/background.png" class="p-img-bj">
				<img :src="item.src" class="p-img">
				<div class="p-right">
					<div class="p-name">{{item.name}}</div>
    				<div class="p-desc">{{item.desc}}</div>
				</div>
    		</div>
    	</div>
    </div>
    <div class="case">
    	<div class="c-title">咨询案例</div>
    	<div class="c-list">
    		<div class="c-que">
    			<img class="que-img" src="/static/img/que.png">
    			<div class="que-t">问</div>
    			<div class="que-main">{{consult.que}}</div>
    		</div>
    		<div class="c-ans">
    			<div class="ans-t">答</div>
    			<div class="ans-main">
    				<div class="ans-list">
    					<div v-for="(item , index) in tag" @click="checkTag(index)">
							<div :class="check == index ? 'ans-btn-che':'ans-btn' ">{{item}}</div>
    					</div>
    				</div>
					<div v-if="check == 0" v-html="consult.ans"></div>
					<div v-if="check == 1" v-html="consult.laws"></div>
					<div v-if="check == 2" v-html="consult.operation"></div>
    			</div>
    		</div>
    	</div>
    </div>

    <div class="consult-icon" @click="gotoHonsenChat">
    	<img src="/static/img/hxj.png" class="consult-img">
    	<div class="consult-name">打开咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalConsult',
  data () {
    return {
      consultAnswer:[
      	{src:'/static/img/consult_answer1.png',name:'解答用户的法律疑问'},
      	{src:'/static/img/consult_answer2.png',name:'提供解决方案或建议'},
      	{src:'/static/img/consult_answer3.png',name:'提供准确的法律依据'}
      ],
      consultProcess:[
      	{src:'/static/img/1.png',name:'智能系统自动响应',desc:'接入用户咨询；第一时间自动响应'},
      	{src:'/static/img/2.png',name:'调取法律文库解答',desc:'简单、常识性法律问题；自动调取法律文库解答'},
      	{src:'/static/img/3.png',name:'复杂疑难问题咨询',desc:'智能系统无法解答；复杂疑难问题'},
      	{src:'/static/img/4.png',name:'自动匹配律师咨询',desc:'自动匹配地域相近、专业对口的律师；团队提供咨询服务'}
      ],
      consult:{
      	que:"我有一个问题想咨询您，我们有个员工2016年10月5日入职，2019年10月4日劳动合同到期，公司从2019年11月就找她续签合同，但她一直拖着不签，现在（2020年2月17日）公司想跟她谈离职，要赔偿多少？",
      	ans:'分两种情况：<br>&nbsp&nbsp&nbsp&nbsp 1、如公司不能证明是员工拒签劳动合同，从2019年11月5日至2020年2月17日，支付双倍工资；在这个情况下解除劳动合同如果公司直接解除，则构成违法解除，还需支付2n的赔偿金；协商一致解除则支付n经济补偿金。<br>&nbsp&nbsp&nbsp&nbsp 2、如公司能够证明员工拒签劳动合同， 并书面通知员工终止劳动关系，只需支付n经济补偿。',
      	laws:'劳动合同法实施条例 <br>&nbsp&nbsp&nbsp&nbsp 第六条 用人单位自用工之日起超过一个月不满一年未与劳动者订立书面劳动合同的，应当依照劳动合同法第八十二条的规定向劳动者每月支付两倍的工资，并与劳动者补订书面劳动合同；劳动者不与用人单位订立书面劳动合同的，用人单位应当书面通知劳动者终止劳动关系，并依照劳动合同法第四十七条的规定支付经济补偿。前款规定的用人单位向劳动者每月支付两倍工资的起算时间为用工之日起满一个月的次日，截止时间为补订书面劳动合同的前一日。<br>劳动合同法 <br>&nbsp&nbsp&nbsp&nbsp 第四十七条  经济补偿按劳动者在本单位工作的年限，每满一年支付一个月工资的标准向劳动者支付。六个月以上不满一年的，按一年计算；不满六个月的，向劳动者支付半个月工资的经济补偿。劳动者月工资高于用人单位所在直辖市、设区的市级人民政府公布的本地区上年度职工月平均工资三倍的，向其支付经济补偿的标准按职工月平均工资三倍的数额支付，向其支付经济补偿的年限最高不超过十二年。本条所称月工资是指劳动者在劳动合同解除或者终止前十二个月的平均工资。',
      	operation:'&nbsp&nbsp&nbsp&nbsp 员工是否拒签劳动合同，是本次事情处理的关键，应注意保留关键证据。谈判时应录音录像，证明系员工拒签而不是公司不愿意签订，然后书面通知因其拒签行为终止劳动关系。<br>&nbsp&nbsp&nbsp&nbsp 提供附件：《续订（终止）劳动合同意向通知书》'

      },
      tag:['问题解答','法律依据','操作指导'],
      check:0
    }
  },
  mounted(){},
  computed:{
  	loginStatus() {
      return this.$store.state.loginStatus;
    },
  },
  methods:{
  	checkTag(index){
  		this.check = index;
  	},
  	//跳转咨询
    gotoHonsenChat() {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      if(this.$store.state.mineInfo.is_lawyer){
        // 律师跳转咨询页
        let details = this.$router.resolve({
          name: "lawyerChat",
          query: {
            
          }
        });
        window.open(details.href, "_blank")
      }else if(this.$store.state.mineInfo.isSupportStaff){
        //客服跳转咨询管理页，
        let details = this.$router.resolve({
            name: "consultSession",
            query: {
              
            }
          });
        window.open(details.href, "_blank")
      }else if(this.honsenOffice){
        //管理员跳转咨询管理页，
        let details = this.$router.resolve({
            name: "customerRecord",
            query: {
              
            }
          });
        window.open(details.href, "_blank")
      }else{
        //用户跳转咨询页
        let details = this.$router.resolve({
          name: "chats",
          query: {
            visitUrl:window.location.href
          }
        });
        window.open(details.href, "_blank")
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/legalConsult/legalConsult.vue